import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import HtmlParser from 'html-react-parser';


import { DemoFormLong } from '../components/DemoFormLong.jsx';

const WistiaPlayer = ({ video }) => {

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://fast.wistia.com/embed/medias/${video}.jsonp`;
        script.async = true;
        document.body.appendChild(script);

        const script2 = document.createElement("script");
        script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
        script2.async = true;

        document.body.appendChild(script2);
    }, [])

    return (
        <div className="wistia_responsive_padding" style={{ padding: "56.25% 0 0 0", margin: "0 0 20px 0", position: "relative", width: "100%" }}>
            <div className="wistia_responsive_wrapper" style={{ height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }}>
                <div className={`wistia_embed wistia_async_${video} videoFoam=true`} style={{ height: "100%", position: "relative", width: "100%" }}>
                    <div className="wistia_swatch" style={{ height: "100%", left: "0", opacity: "0", overflow: "hidden", position: "absolute", top: "0", transition: "opacity 200ms", width: "100%" }}>
                        <img src={`https://fast.wistia.com/embed/medias/${video}/swatch`} style={{ filter: "blur(5px)", height: "100%", width: "100%" }} alt="Chart Example" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>
    );
}

const VideoTemplate = (props) => {
    const location = props.location;
    const videoPage = props.data.markdownRemark;
    const { description } = props.data.markdownRemark;
    const { title_fb } = props.data.markdownRemark.frontmatter.seo;
    const { description_fb } = props.data.markdownRemark.frontmatter.seo;
    const { metaimg } = props.data.markdownRemark.frontmatter.seo;
    const metaImgUrl = `https://www.charthop.com${metaimg}`;
    const { title_twitter } = props.data.markdownRemark.frontmatter.seo;
    const { description_twitter } = props.data.markdownRemark.frontmatter.seo;
    const shareurl = `https://www.charthop.com${location.pathname}`;

    let urlArray = location.pathname.split('/');;
    let urlTitle = (urlArray && urlArray[urlArray.length - 2]);

    return (
        <Layout  bodyClass="page-home" ontouchstart>
            <SEO title="ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content={description}
                />
                <meta property="og:url" content={shareurl} />
                <meta property="og:title" content={title_fb} />
                <meta property="og:description" content={description_fb} />
                <meta property="og:image" content={metaImgUrl} />
                <meta property="og:type" content="website" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content={title_twitter} />
                <meta name="twitter:description" content={description_twitter} />
                <meta name="twitter:image" content={metaImgUrl} />
                <meta name="twitter:card" content="summary_large_image" />

            </Helmet>
            {/* PAGE CONTENT */}
            <section className="container introductionVideoPage intro-video">
                <div className="row align-items-center">
                    <div className="introducing-charthop-video col-12 space-with-video video-title">
                        <h1>{videoPage.frontmatter.title}</h1>
                        {videoPage.frontmatter.video && <WistiaPlayer video={videoPage.frontmatter.video} />}
                        {videoPage.frontmatter.YbVideo && <div className="iframe-content" style={{ margin: "0 0 20px 0", width: "100%" }} dangerouslySetInnerHTML={{ __html: videoPage.frontmatter.YbVideo }} />}
                        <div className="content pt-1 pb-1" dangerouslySetInnerHTML={{ __html: videoPage.html }} />
                    </div>
                </div>
            </section>




            {/* CONTACT FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={`resources-videos-${urlTitle || ''}-demo-bottom`} headertext={HtmlParser("<h1>See how ChartHop can help!</h1><h1> Request a demo now.</h1>")} focusID={HtmlParser("name")} />
            </section>
            
        </Layout>
    );
};


export default VideoTemplate;


export const query = graphql `
  query($id: String!) {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
        
      }
    }
    markdownRemark(id: { eq: $id }) {
        frontmatter {
          title
          path
          video
          YbVideo
          description
          seo{
            seotitle
            metaimg
            title_fb
            description_fb
            title_twitter
            description_twitter
          }
        }
        html
        id
    }
  }
`;